import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { RefObject, useState } from 'react'

import { BlogPostService } from '../../../services/BlogPost/BlogPostService'
import { BlogPost } from '../../../services/BlogPost/types'

export interface IDeleteBlogPostDialogProps {
  isOpen: boolean
  onClose: () => void
  blogPost: BlogPost
  leastDestructiveRef: RefObject<HTMLButtonElement>
}

export function BlogPostDeleteDialog({ isOpen, onClose, blogPost, leastDestructiveRef }: IDeleteBlogPostDialogProps) {
  const service = new BlogPostService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await service.delete(blogPost.id)

      toast({
        title: 'Post excluído com sucesso',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao excluir post',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={leastDestructiveRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Excluir Post do Blog
          </AlertDialogHeader>

          <AlertDialogBody>
            Tem certeza de que deseja excluir o post <strong>{blogPost.title}</strong>?
            <br />
            Esta ação não pode ser desfeita.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={leastDestructiveRef} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Excluir
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
